export const LOGIN_MESSAGES = {
  EMPTY_USERNAME: 'Please input your username!',
  EMPTY_PASSWORD: 'Please input your password!',
};
